export default class FeedbackFormatter {
    constructor(feedbackData) {
        this.rawData = feedbackData;
    }

    getSingleVal(array) {
        let value = '';
        array.forEach(element => {
            if (element != null || element != undefined) {
                value = element;
            }
        });

        return value;
    }

    compilePinData(pinArray) {
        return `${pinArray[0]}, ${pinArray[1]}`;
    }

    format() {
        return {
            first_name: this.rawData.address.firstName,
            last_name: this.rawData.address.lastName,
            address_line1: this.rawData.address.firstAddressLine,
            address_line2: this.rawData.address.secondLineAddress,
            town_city: this.rawData.address.townCity,
            postcode: this.rawData.address.postCode,
            email: this.rawData.address.emailAddress,
            organisation: this.rawData.address.organisation,
            question1_1: this.rawData.question1[0],
            question1_2: this.rawData.question1[1],
            question1_3: this.rawData.question1[2],
            question1_4: this.rawData.question1[3],
            question1_5: this.rawData.question1[4],
            question2_1: this.rawData.question2[0],
            question2_2: this.rawData.question2[1],
            question2_3: this.rawData.question2[2],
            question2_4: this.rawData.question2[3],
            question2_5: this.rawData.question2[4],
            question2_6: this.rawData.question2[5],
            question2_7: this.rawData.question2[6],
            question3: this.rawData.question3[0],
            queston4: this.getSingleVal(this.rawData.question4),
            question5: this.rawData.question5[0],
            question6_1: this.rawData.question6[0],
            question6_2: this.rawData.question6[1],
            question7_1: this.rawData.question7[0],
            question7_2: this.rawData.question7[1],
            question7_3: this.rawData.question7[2],
            question8_1: this.rawData.question8[0],
            question8_2: this.rawData.question8[1],
            question8_3: this.rawData.question8[2],
            question8_4: this.rawData.question8[3],
            question8_5: this.rawData.question8[4],
            question8_6: this.rawData.question8[5],
            question8_7: this.rawData.question8[6],
            question8_8: this.rawData.question8[7],
            question9_pin_1_coord: this.compilePinData(this.rawData.question9[0].coords),
            question9_pin_1_comment: this.rawData.question9[0].comment,
            question9_pin_2_coord: this.compilePinData(this.rawData.question9[1].coords),
            question9_pin_2_comment: this.rawData.question9[1].comment,
            question9_pin_3_coord: this.compilePinData(this.rawData.question9[2].coords),
            question9_pin_3_comment: this.rawData.question9[2].comment,
            question9_pin_4_coord: this.compilePinData(this.rawData.question9[3].coords),
            question9_pin_4_comment: this.rawData.question9[3].comment,
            question9_pin_5_coord: this.compilePinData(this.rawData.question9[4].coords),
            question9_pin_5_comment: this.rawData.question9[4].comment,
            choice_1: this.rawData.choice1,
            choice_2: this.rawData.choice2,
            choice_3: this.rawData.choice3,
            question11_combination1: this.rawData.question11[0],
            question11_combination2: this.rawData.question11[1],
            question11_combination3: this.rawData.question11[2],
            question11_combination4: this.rawData.question11[3],
            question11_combination5: this.rawData.question11[4],
            other_comments: this.rawData.comments
        }
    }
}